<template>
  <v-container fluid @scroll="onScroll($event)" @click="removeSelection()">
    <v-layout>
      <v-flex xs12 sm10 offset-sm1 lg6 offset-lg3>
        <v-toolbar dense flat fixed style="top: 64px; z-index: 1;" :height="$vuetify.breakpoint.smAndDown ? (user.isStore || user.isRequester || user.isAdmin ? '170px' : '80px') : '66px'">
          <v-container fluid class="ma-0 px-0">
            <v-layout>
              <v-flex xs12 sm10 offset-sm1 lg6 offset-lg3>
                <v-container fluid class="mx-0 my-1 pa-0">
                  <v-layout row wrap>
                    <v-flex xs4 md2 d-inline-block class="px-0 py-0 my-2">
                      <v-btn class="pa-0 mx-0 my-2" large block outline active-class="v-btn--active primary"
                        @click="state.listView=!state.listView">
                        {{state.listView ? 'kartice' : 'tabela'}}
                      </v-btn>
                    </v-flex>
                    <v-flex xs4 md2 d-inline-block class="px-1 py-0 my-2">
                      <v-btn class="pa-0 mx-0 my-2" large block outline v-model="state.showActive" active-class="v-btn--active primary"
                        @click="state.showActive=!state.showActive||!state.showNew;state.showAll=false;state.showLoadMore=true">
                        aktivne
                      </v-btn>
                    </v-flex>
                    <v-flex xs4 md2 d-inline-block class="px-0 py-0 my-2">
                      <v-btn class="pa-0 mx-0 my-2" large block outline v-model="state.showNew" active-class="v-btn--active primary"
                        @click="state.showNew=!state.showNew||!state.showActive;state.showAll=false;state.showLoadMore=true">
                        nove
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 md5 offset-md1 d-inline-block class="px-0 py-0 my-2">
                      <v-btn class="primary pa-0 mx-0 my-2" large block to="/delivery/new" v-if="user.isStore || user.isRequester || user.isAdmin">
                        <v-icon class="mr-2">fa-edit</v-icon>
                        Nova dostava
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
              <v-btn v-if="deliveriesCounter.newDeliveries > 0 && user.isCourier" round large color="primary" bottom right absolute 
                @click="$el.scrollIntoView({ behavior: 'smooth' })">
                <h1>Nove dostave: {{ deliveriesCounter.newDeliveries }}</h1>
              </v-btn>
            </v-layout>
          </v-container>
        </v-toolbar>

        <div :style="$vuetify.breakpoint.smAndDown ? (user.isStore || user.isRequester || user.isAdmin ? 'height:170px' : 'height:80px') : 'height:60px'"></div>

        <!-- Tiles -->
        <delivery-view v-for="(delivery, i) in deliveries"
          :key="i"
          @click.native.stop="selectDelivery(delivery)"
          v-if="!state.listView && isVisible(delivery)" 
          :delivery="delivery"
          :expanded="delivery==selectedDelivery">
        </delivery-view>
        <!-- Tiles end -->

        <!-- Table -->
        <v-data-table
           v-if="state.listView"
           :headers="headers"
           :items="deliveries"
           hide-actions
           class="elevation-1"
           :loading="state.loading"
         >
          <template slot="items" slot-scope="props">
            <tr @click.prevent="selectDelivery(props.item)">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.from_name }}</td>
              <td>{{ props.item.from_address }}</td>
              <td>{{ props.item.to_name }}</td>
              <td>{{ props.item.to_address }}</td>
              <td>{{ formatDate(props.item.time_accepted) }}</td>
              <td>{{ formatDate(props.item.time_picked_up) }}</td>
              <td>{{ formatDate(props.item.time_delivered) }}</td>
              <td>{{ props.item.courier_id }}</td>
            </tr>
          </template>
          <template slot="no-data">
             učitavanje...
          </template>
        </v-data-table
        <!-- Table end -->

        <v-btn class="pa-0 mx-0 my-2" large block outline
          v-if="state.showLoadMore"
          @click="loadMore()"
          :loading="state.loading">
          učitaj i završene dostave
        </v-btn>

      </v-flex>

      <v-dialog v-model="assignDialog" max-width="400px">
        <v-card>
          <v-card-title class="primary"><h4>Dodeli kuriru</h4></v-card-title>
          <v-divider></v-divider>
          <v-list dense>
            <v-list-tile v-for="(courier, j) in couriers" :key="j" @click="selectCourier(courier)" :class="{ accent : courier.selected }">
              <v-list-tile-content>
                <span v-bind:style="{color: courier.online == 0 ? 'gray' : 'inherit'}">
                  <span>{{ courier.name }}</span>
                  <span><v-btn fab dark small v-bind:color="courier.online ? 'green' : 'grey'">{{ courier.active_deliveries_count }}</v-btn></span>
                  <span>{{ courier.latest_address }}</span>
                  <i>{{ formatTimeCourier(courier.latest_event) }}</i>
                </span></v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-btn class="primary" block large @click.prevent="assignDelivery">Ok</v-btn>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import 'moment/locale/sr'
import _ from 'underscore'
import auth from '@/services/authService'
import deliveryService from '@/services/deliveryService'
import userService from '@/services/userService'
import DeliveryView from '@/components/DeliveryView'
let refreshInterval
let state = {
  showAll: false,
  showActive: true,
  showNew: true,
  showLoadMore: true,
  loading: false,
  listView: false
}
let couriers = {}
export default {
  data () {
    return {
      user: auth.getCurrentUser(),
      deliveries: this.updateDeliveriesStatuses(deliveryService.getDeliveries()),
      state,
      assignDialog: false,
      selectedDelivery: null,
      selectedCourier: null,
      couriers: userService.getCouriers(),
      deliveriesCounter: deliveryService.counter(),
      headers: [
        { text: 'id', value: 'id' },
        { text: 'radnja', value: 'from_name' },
        { text: 'adresa radnje', value: 'from_address' },
        { text: 'odredište', value: 'to_name' },
        { text: 'adresa odredišta', value: 'to_address' },
        { text: 'primljeno', value: 'time_accepted' },
        { text: 'preuzeto', value: 'time_picked_up' },
        { text: 'dostavljeno', value: 'time_delivered' },
        { text: 'kurir', value: 'courier_id' }
      ],
      statusRefresh: 0
    }
  },
  components: {
    DeliveryView
  },
  created () {
    refreshInterval = setInterval(() => {
      this.updateDeliveriesStatuses(deliveryService.getDeliveries())
      this.statusRefresh++
    }, 20000)
  },
  destroyed () {
    clearInterval(refreshInterval)
  },
  watch: {
    deliveries: function () {
      this.calculateCourierLastActivity()
    },
    couriers: function () {
      this.calculateCourierLastActivity()
    }
  },
  methods: {
    loadMore () {
      this.state.showAll = true
      this.state.showActive = false
      this.state.showNew = false
      this.state.loading = true
      deliveryService.getDeliveriesPromise((_.reduce(this.deliveries, (last, current) => last.id < current.id ? last : current) || {}).id)
        .then(deliveries => {
          if (deliveries.length === 0) {
            this.state.showLoadMore = false
          }
        }).finally(() => {
          this.state.loading = false
        })
    },
    calculateCourierLastActivity () {
      if (this.deliveries.length === 0 || this.couriers.length === 0) {
        return
      }
      this.deliveries.forEach(delivery => {
        if (!couriers.hasOwnProperty(delivery.courier_id)) {
          couriers[delivery.courier_id] = _.find(this.couriers, courier => courier.id === delivery.courier_id)
        }
        let courier = couriers[delivery.courier_id]
        if (courier) {
          if (!courier.latest_event || courier.latest_event < delivery.time_picked_up) {
            courier.latest_event = delivery.time_picked_up
            courier.latest_address = delivery.from_address
          }
          if (courier.latest_event < delivery.time_delivered) {
            courier.latest_event = delivery.time_delivered
            courier.latest_address = delivery.to_address
          }
        }
      })
    },
    newDelivery () {
      this.$router.push(`/delivery/new`)
    },
    formatDate (d) {
      return d ? moment(d).format('Do MM, HH:mm') : ''
    },
    formatTime (d) {
      return d ? moment(d).format('HH:mm') : 'što pre'
    },
    formatTimeCourier (d) {
      return d ? moment(d).format('HH:mm') : ''
    },
    getStatus (delivery) {
      let status = deliveryService.getDeliveryStatus(delivery)
      status.isActive = status.name !== 'delivered' && status.name !== 'cancelled'
      status.isPendingPickup = status.name === 'accepted' || status.name === 'lateToPickup'
      // ??? status.isPendingPickup = this.user.id === delivery.courier_id
      return status
    },
    updateDeliveriesStatuses (deliveries) {
      for (const delivery of deliveries) {
        if (delivery) {
          delivery.status = this.getStatus(delivery)
        }
      }
      return deliveries
    },
    isAssignable (delivery) {
      return this.user.isProxy &&
        (delivery.courier_id === this.user.id || delivery.agency_id === this.user.id) &&
        this.getStatus(delivery).isActive && delivery.time_picked_up === null
    },
    isAssigned (delivery) {
      return delivery.courier_id !== this.user.id
    },
    isVisible (delivery) {
      let status = this.getStatus(delivery).name
      return state.showAll ||
        (state.showNew && (status === 'open' || status === 'openLate')) ||
        (state.showActive && (status === 'transit' ||
            status === 'accepted' || status === 'lateToPickup' || status === 'lateToDeliver' ||
            (status === 'delivered' && moment().diff(delivery.time_delivered, 'minutes') < 30) ||
            (status === 'cancelled' && moment().diff(delivery.time_created, 'minutes') < 60)))
    },
    selectDelivery (delivery) {
      this.selectedDelivery = delivery
      // this.$router.push(`/delivery/${delivery.id}`)
    },
    removeSelection () {
      this.selectedDelivery = null
    },
    selectCourier (courier) {
      this.couriers.forEach(c => { c.selected = (c.id === courier.id && this.selectedCourier !== courier) })
      this.selectedCourier = this.selectedCourier !== courier ? courier : null
      this.$forceUpdate()
    },
    openAssignDialog (delivery) {
      this.selectedDelivery = delivery
      userService.getCouriersPromise().then(() => {
        this.assignDialog = true
        this.couriers.forEach(c => {
          if (c.id === delivery.courier_id) {
            this.selectedCourier = c
            c.selected = true
          } else {
            c.selected = false
          }
        })
      })
    },
    assignDelivery () {
      if (this.selectedCourier !== null) {
        let deliveryId = this.selectedDelivery.id
        deliveryService.assignDelivery(this.selectedDelivery, this.selectedCourier).then(() => {
          deliveryService.getDelivery(deliveryId)
          this.assignDialog = false
          this.selectedCourier = null
        }).catch(error => {
          console.log('assign delivery failed', error)
          userService.getCouriers()
        })
      } else {
        this.assignDialog = false
        this.selectedCourier = null
      }
    },
    onScroll (e) {
      // console.log(e)
      // console.log(e.target.scrollTop, e.target.innerHeight)
    }
  }
}
</script>

<style>
.delivery-card.open {
  border: 1px solid #2181C4;
}
.delivery-card.accepted {
  border: 1px solid #868478;
}
.delivery-card.transit {
  border: 1px solid #868478;
}
.delivery-card.delivered {
  border: 1px solid #E1DCD5;
}
.delivery-card.cancelled {
  border: 1px solid #FF776A;
}
.delivery-card.openLate {
  border: 1px solid #FFAC1F;
}
.delivery-card.lateToPickup {
  border: 1px solid #FFAC1F;
}
.delivery-card.lateToDeliver {
  border: 1px solid #FFAC1F;
}
.delivery-status {
  width: 100%;
}
.delivery-status.open {
  background-color: #2181C4;
}
.delivery-status.accepted {
  background-color: #868478;
}
.delivery-status.transit {
  background-color: #868478;
}
.delivery-status.delivered {
  background-color: #E1DCD5;
}
.delivery-status.cancelled {
  background-color: #FF776A;
}
.delivery-status.openLate {
  background-color: #FFAC1F;
}
.delivery-status.lateToPickup {
  background-color: #FFAC1F;
}
.delivery-status.lateToDeliver {
  background-color: #FFAC1F;
}
.delivery-party {
  overflow: auto;
}
.delivery-left-col {
  width: 67%;
  display: inline-block;
}
.delivery-right-col {
  width: 30%;
  display: inline-block;;
}
.v-btn.v-btn--outline.v-btn--active {
  background-color: #2181c4 !important;
}
.isPendingPickup {
  color: #2181c4 !important;
}
</style>
<style>
.v-list__tile {
  height: 48px !important;
}
</style>
